import axios from 'axios'
import cookie from 'react-cookies'
import imageCompression from 'browser-image-compression'
import { notify } from 'react-notify-toast'
import moment from 'moment'
import ApiURL from './ApiUrl'

import { createMiazgaNutshellStripeSession } from './challengesApi'

import { boolean } from 'yup/lib/locale'

export const LoginUser = async (email, password) => {
  let isLoginSuccess = false
  let message

  await axios
    .post(`${ApiURL}/api/auth/users/token_obtain/`, {
      email: email,
      password: password,
    })
    .then((response) => {
      if (response.status === 200) {
        cookie.save('accessToken', response.data.access)
        cookie.save('refreshToken', response.data.refresh)
        isLoginSuccess = true
      }
    })
    .catch(({ response, error }) => {
      notify.show(`${response.data.message}`, 'error', 3000)
    })

  return isLoginSuccess
}

export const registerUser = async (
  email,
  password,
  isUserCheckedNewsletterChheckbox
) => {
  let registerSuccess = false
  await axios
    .post(`${ApiURL}/api/auth/users/register/`, {
      email: email,
      password: password,
      is_newsletter_subscriber: isUserCheckedNewsletterChheckbox,
    })

    .then((response) => {
      if (response.status === 200 || response.status === 201) {
        notify.show(
          'Poprawnie zarejestrowano nowe konto. Proszę sprawdź podany adres email by aktywować konto.',
          'success',
          5000
        )
        registerSuccess = true
      }
    })
    .catch(({ error, response }) => {
      if (response.status === 409) {
        notify.show(
          'Konto o podanym adresie nie może zostać zarejestrowane.',
          'error',
          5000
        )
        return
      }
      notify.show(`${response.data.message}`, 'error', 5000)
    })
  return registerSuccess
}

export const addUserFeed = async (
  belly_circumference,
  hip_circumference,
  thigh_circumference,
  creation_datetime
) => {
  const setUserFeed = {
    method: 'post',
    url: `${ApiURL}/api/feeds/`,
    data: {
      belly_circumference: belly_circumference,
      hip_circumference: hip_circumference,
      thigh_circumference: thigh_circumference,
      creation_datetime: creation_datetime,
    },
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  axios(setUserFeed)
    .then((response) => {
      if (response.status == 201)
        notify.show(`Poprawnie dodano pomiary wpisu`, 'success', 5000)
    })
    .catch((error, response) => {
      let msg = 'Coś poszło nie tak...'
      if (response?.data) {
        if (response?.data?.message) {
          msg = response.data.message
        } else if (response?.data?.detail) {
          msg = response.data.detail
        }
      }
      notify.show(`Ups... ${msg}`, 'error', 5000)
    })
}

export const patchUserData = async (
  name,
  show_intro,
  is_profile_complete,
  userId
) => {
  let result
  const patchUserDataConfig = {
    method: 'patch',
    url: `${ApiURL}/api/auth/users/${userId}/`,
    data: {
      name: name,
      show_intro: show_intro,
      is_profile_complete: is_profile_complete,
    },
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  await axios(patchUserDataConfig)
    .then((response) => {
      result = response
    })
    .catch((error) => {
      result = error.response
      if (error.status === 401) {
        // refreshToken()
      } else {
      }
    })

  return result
}

export const patchUserWatchedIntro = async (show_intro, userId) => {
  const patchUserWatchedIntroConfig = {
    method: 'patch',
    url: `${ApiURL}/api/auth/users/${userId}/`,
    data: {
      show_intro: show_intro,
    },
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  await axios(patchUserWatchedIntroConfig)
    .then((response) => {})
    .catch((error) => {
      if (error.status === 401) {
        // refreshToken()
        // patchUserData(name, show_intro, is_profile_complete, userId)
      } else {
        console.log(error)
      }
    })
}

function getAccessTokenFromCookies() {
  return cookie.load('accessToken')
}

// const refreshAuthLogic = (failedRequest) => {
//   refreshToken()

//   setTimeout(() => {
//     failedRequest.response.config.headers[
//       'Authorization'
//     ] = `Bearer ${getAccessTokenFromCookies()}`
//   }, 300)
// }

// createAuthRefreshInterceptor(axios, refreshAuthLogic)

export const getUserData = async () => {
  let userData

  const getUserDataConfig = {
    method: 'get',
    url: `${ApiURL}/api/auth/users/me/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  await axios(getUserDataConfig)
    .then((response) => {
      userData = response.data
    })
    .catch((error, response) => {
      console.log(error)

      // refreshToken()
      if (error.status === 401) {
      } else {
        console.log(error)
      }
    })
  return userData
}

export const setUserFeed = (
  bellyCircumference,
  hipCircumference,
  thighCircumference
) => {
  const setUserFeedConfig = {
    method: 'post',
    url: `${ApiURL}/api/feeds/`,
    data: {
      belly_circumference: bellyCircumference,
      hip_circumference: hipCircumference,
      thigh_circumference: thighCircumference,
      creation_datetime: true,
    },
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  axios(setUserFeedConfig)
    .then((response) => {})
    .catch((error) => {
      console.log(error)

      if (error.status === 401) {
        // refreshToken()
        // setUserFeed()
      } else {
        console.log(error)
      }
    })
}

export const geSpecifictUserFeed = async (id) => {
  let result
  const getUserSpecificFeedConfig = {
    method: 'get',
    url: `${ApiURL}/api/feeds/${id}/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  await axios(getUserSpecificFeedConfig)
    .then((response) => {
      result = response.data
    })
    .catch(async (error) => {
      console.log(error)

      if (error.status === 401) {
        // await refreshToken()
        // await geSpecifictUserFeed(id)
      } else {
        console.log(error)
      }
    })

  return result
}

export const getUserFeed = async () => {
  let result
  const getUserFeedConfig = {
    method: 'get',
    url: `${ApiURL}/api/feeds/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  await axios(getUserFeedConfig)
    .then((response) => {
      result = response.data
    })
    .catch(async (error) => {
      console.log(error)

      if (error.status === 401) {
        // await refreshToken()
        // await getUserFeed()
      } else {
        console.log(error)
      }
    })

  return result
}

export const uploadFileToAmazon = async (file, uploadUrl) => {
  const instance = axios.create()
  const formData = new FormData()
  let uploadSuccess = false
  formData.append('image', file)
  instance
    .put(uploadUrl, file, {
      headers: { 'Content-Type': file.type },
    })
    .then((result) => {
      notify.show('Poprawnie dodano zdjęcie!', 'success', 1000)
      uploadSuccess = true
    })
    .catch((err) => {
      uploadSuccess = false
      console.log(err)
      notify.show(`Ups! ${err}`, 'error', 1000)
    })

  return uploadSuccess
}

export const compressImages = async (file, uploadUrl) => {
  let compressedAndUploaded
  const options = {
    maxSizeMB: 1,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
  }

  try {
    const compressedFile = await imageCompression(file, options)

    uploadFileToAmazon(compressedFile, uploadUrl)
    compressedAndUploaded = true
  } catch (error) {
    console.log(error)
    compressedAndUploaded = false
  }
  return compressedAndUploaded
}

export const setUserTrainingDays = async (trainingDays, hour, minute) => {
  let result

  const setUserTrainingDaysConfig = {
    method: 'post',
    url: `${ApiURL}/api/training/`,
    data: { days: trainingDays, hour, minute },
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  let setTrainingDaysSuccess = false

  await axios(setUserTrainingDaysConfig)
    .then((response) => {
      result = response
    })
    .catch((error) => {
      console.log(error)

      if (error.status == 401) {
        // refreshToken()
        // setUserTrainingDays()
      } else {
        console.log(error)
      }
    })

  return result
}

export const getTrainingDays = async () => {
  let userTrainingData
  const getTrainingDaysConfig = {
    method: 'get',
    url: `${ApiURL}/api/training/my_training/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  await axios(getTrainingDaysConfig)
    .then((response) => {
      userTrainingData = {
        trainingDays: response.data.days,
        trainingId: response.data.id,
        notification_enabled: response.data.notification_enabled,
        hour: response.data.hour,
        minute: response.data.minute,
      }
    })
    .catch((error) => {
      console.log(error)
      if (error.status === 401) {
        // refreshToken()
        // this.getTrainingDays()
      }
    })
  return userTrainingData
}

export const editUserTrainingDays = async (
  trainingDays,
  trainingId,
  splittedTime,
  notification_enabled
) => {
  const editUserTrainingDaysConfig = {
    method: 'put',
    url: `${ApiURL}/api/training/${trainingId}/`,
    data: {
      days: trainingDays,
      hour: splittedTime[0],
      minute: splittedTime[1],
      notification_enabled: notification_enabled,
    },
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  let userTrainingData
  await axios(editUserTrainingDaysConfig)
    .then((response) => {
      notify.show('Poprawnie zaktualizowano dane o treningu.', 'success', 2000)
      if (response.status === 200) {
        userTrainingData = {
          trainingDays: response.data.days,
          trainingId: response.data.id,
          notification_enabled: response.data.notification_enabled,
          hour: response.data.hour,
          minute: response.data.minute,
        }
      }
    })

    .catch((error) => {
      console.log(error)
      notify.show(`Ups, ${error.status}`, 'error', 2000)
      if (error.status == 401) {
        // refreshToken()
        // this.editUserTrainingDays(
        //   trainingDays,
        //   trainingId,
        //   splittedTime,
        //   notification_enabled
        // )
      }
    })

  return userTrainingData
}

export const editImage = async (side, image, imageId) => {
  let imageName
  const date = new Date()

  const correctDate = moment(date).format('YYYY-MM-DD')

  switch (side) {
    case 'S':
      imageName = 'side_image.jpg'
      break
    case 'F':
      imageName = 'front_image.jpg'
      break
    case 'B':
      imageName = 'back_image.jpg'
      break
    default:
      break
  }

  let result
  const generateEditPhotoAwsUrlConfig = {
    method: 'PUT',
    url: `${ApiURL}/api/aws/photos/${imageId}/`,
    data: {
      filename: imageName,
      type: side,
      feed_datetime: correctDate,
    },
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  await axios(generateEditPhotoAwsUrlConfig)
    .then((response) => {
      result = response.data

      compressImages(image, response.data.upload_url)
      // uploadFileToAmazon(image, response.data.upload_url)
    })
    .catch((error) => {
      console.log(error)

      // if (error.status == 400) {
      //   notify.show(
      //     'Zdjęcie tej strony ciała zostało już dzisiaj dodane',
      //     'error',
      //     2000
      //   )
      // }
    })

  return result
}

export const generatePhotoAwsUrl = async (side, image) => {
  let imageName
  const date = new Date()
  let generatedImage = false

  const correctDate = moment(date).format('YYYY-MM-DD')

  switch (side) {
    case 'S':
      imageName = 'side_image.jpg'
      break
    case 'F':
      imageName = 'front_image.jpg'
      break
    case 'B':
      imageName = 'back_image.jpg'
      break
    default:
      break
  }

  let result
  const generatePhotoAwsUrlConfig = {
    method: 'POST',
    url: `${ApiURL}/api/aws/photos/`,
    data: {
      filename: imageName,
      type: side,
      feed_datetime: correctDate,
    },
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  await axios(generatePhotoAwsUrlConfig)
    .then(async (response) => {
      result = response.data

      generatedImage = await compressImages(image, response.data.upload_url)
    })
    .catch((error) => {
      console.log(error)

      if (error.status === 401) {
        // refreshToken()
        // generatePhotoAwsUrl(side, image)
      }
      // else if (error.status == 400) {
      //   notify.show(
      //     'Zdjęcie tej strony ciała zostało już dzisiaj dodane',
      //     'error',
      //     2000
      //   )
      // }
    })

  return generatedImage
}

export const getPhotos = async () => {
  let result
  const getPhotosConfig = {
    method: 'GET',
    url: `${ApiURL}/api/aws/photos/`,

    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  await axios(getPhotosConfig)
    .then((response) => {
      result = response.data
    })
    .catch((error) => {
      console.log(error)

      if (error.status == 401) {
        // refreshToken()
        // generatePhotoAwsUrl()
      } else {
        console.log(error)
      }
    })

  return result
}

export const getUserLoggedInWithSocial = async (
  userEmail,
  userId,
  userToken,
  mode
) => {
  let isUserAuthenticated = false

  let url
  if (mode === 'google') {
    url = `${ApiURL}/api/auth/users/google_auth/`
  } else {
    url = `${ApiURL}/api/auth/users/facebook_auth/`
  }
  const getUserTokenFromSocialConfig = {
    method: 'POST',
    url,
    data: {
      email: userEmail,
      user_id: userId,
      user_token: userToken,
    },
  }

  await axios(getUserTokenFromSocialConfig)
    .then((response) => {
      if (response.status === 200) {
        isUserAuthenticated = true
        cookie.remove('accessToken')
        cookie.save('accessToken', response.data.access)
        cookie.remove('refreshToken')
        cookie.save('refreshToken', response.data.refresh)
      }
    })
    .catch((error) => {
      console.log(error)
    })
  return isUserAuthenticated
}

export const remindUserPassword = (email) => {
  const remindUserPasswordConfig = {
    method: 'POST',
    url: `${ApiURL}/api/auth/users/send_reset_password_email/`,
    data: {
      email,
    },
  }

  axios(remindUserPasswordConfig)
    .then((response) => {
      notify.show(
        'Poprawnie zresetowano hasło. Sprawdź podany adres email i kliknij w wysłany link by aktywować nowe hasło.',
        'success',
        2000
      )
    })
    .catch((error) => {
      console.log(error)
      notify.show('Wystąpił błąd podczas resetowania hasła', 'error', 2000)
      if (error.status == 401) {
        // refreshToken()
        // remindUserPassword()
      } else {
        console.log(error)
      }
    })
}

export const createUserPaymentSessionSubscription = async (
  mode,
  stripeProductName
) => {
  let result
  let createUserPaymentSessionConfig

  if (mode == 'one' || mode == 'three') {
    const path =
      mode == 'one'
        ? '/api/inappsubscriptions/stripe/one_month_subscription_session/'
        : '/api/inappsubscriptions/stripe/three_months_subscription_session/'

    createUserPaymentSessionConfig = {
      method: 'POST',
      url: `${ApiURL}${path}`,
      headers: {
        Authorization: 'Bearer ' + cookie.load('accessToken'),
      },
    }
  } else {
    createUserPaymentSessionConfig = {
      method: 'POST',
      url: `${ApiURL}/api/stripe_controller/create_session_one_time_checkout/`,
      headers: {
        Authorization: 'Bearer ' + cookie.load('accessToken'),
      },
      data: {
        name: stripeProductName,
      },
    }
  }

  await axios(createUserPaymentSessionConfig)
    .then((response) => {
      result = response.data
    })
    .catch((error) => {
      if (error.status == 401) {
        // refreshToken()
        // createUserPaymentSession()
      } else {
        console.log(error)
      }
    })
  return result
}

export const createUserPaymentSession = async (mode, stripeProductName) => {
  let result
  let createUserPaymentSessionConfig

  if (mode == 'nutshell1' || mode == 'nutshell2') {
    if (mode == 'nutshell1') {
      return (result = await createMiazgaNutshellStripeSession('9569537'))
    } else {
      return (result = await createMiazgaNutshellStripeSession('9755221'))
    }
  } else {
    if (mode == 'one' || mode == 'three' || mode == 'old-three') {
      const path =
        mode == 'one'
          ? '/api/inappsubscriptions/stripe/one_month_subscription_session/'
          : mode == 'old-three'
          ? '/api/stripe_controller/create_session_three_month_checkout/'
          : '/api/inappsubscriptions/stripe/three_months_subscription_session/'

      createUserPaymentSessionConfig = {
        method: 'POST',
        url: `${ApiURL}${path}`,
        headers: {
          Authorization: 'Bearer ' + cookie.load('accessToken'),
        },
      }
    } else {
      createUserPaymentSessionConfig = {
        method: 'POST',
        url: `${ApiURL}/api/stripe_controller/create_session_one_time_checkout/`,
        headers: {
          Authorization: 'Bearer ' + cookie.load('accessToken'),
        },
        data: {
          name: stripeProductName,
        },
      }
    }

    await axios(createUserPaymentSessionConfig)
      .then((response) => {
        result = response.data

        if (response.status == 204) {
          result = 204
        }
      })
      .catch((error) => {
        if (error.status == 401) {
          // refreshToken()
          // createUserPaymentSession()
        } else {
          notify.show(`${error.response.data.message}`, 'error', 3000)
          setTimeout(() => {
            window.location.reload()
          }, 3000)
        }
      })
  }
  return result
}

export const bindUserAccounts = async (
  email,
  password,
  isUserCheckedNewsletterChheckbox
) => {
  const bindUserAccountsConfig = {
    method: 'POST',
    url: `${ApiURL}/api/auth/users/bind_accounts/`,
    // headers: {
    //   Authorization: 'Bearer ' + cookie.load('accessToken'),
    // },
    data: {
      email: email,
      password: password,
      is_newsletter_subscriber: isUserCheckedNewsletterChheckbox,
    },
  }

  await axios(bindUserAccountsConfig)
    .then((response) => {
      notify.show(
        'Poprawnie połączono konto. Proszę sprawdź podany adres email by aktywować konto.',
        'success',
        3000
      )
    })
    .catch(({ error, response }) => {
      console.log(error)

      notify.show(`${response.data.message}`, 'error', 5000)

      if (error.status == 401) {
        // refreshToken()
        // bindUserAccounts()
      } else {
        console.log(error)
      }
    })
}

export const openStripePortalSession = async () => {
  let respo
  const createUserPaymentSessionConfig = {
    method: 'POST',
    url: `${ApiURL}/api/stripe_controller/create_customer_portal_session/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  await axios(createUserPaymentSessionConfig)
    .then((response) => {
      respo = response

      console.log(respo)
    })
    .catch((error) => {
      console.log(error)
    })
  return respo
}

export const getHydrationAlert = async () => {
  let respo
  const hydrationAlertConfig = {
    method: 'GET',
    url: `${ApiURL}/api/hydration_alert/my_hydration_alert/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  await axios(hydrationAlertConfig)
    .then((response) => {
      respo = response
    })
    .catch((error) => {
      // console.log(error.)
      console.log(error)

      if (error.status == 401) {
        // refreshToken()
        // this.hydrationAlert()
      } else {
        console.log(error)
        respo = false
      }
    })
  return respo
}

export const patchHydrationAlert = async (
  startHour,
  endHour,
  notificationEnabled,
  hydrationId
) => {
  const patchHydrationAlertConfig = {
    method: 'PATCH',
    url: `${ApiURL}/api/hydration_alert/${hydrationId}/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
    data: {
      start_hour: startHour,
      end_hour: endHour,
      notification_enabled: notificationEnabled,
    },
  }

  await axios(patchHydrationAlertConfig)
    .then((response) => {
      notify.show('Poprawnie zmieniono dane o piciu wody.', 'success', 2000)
    })
    .catch((error) => {
      // console.log(error.)
      console.log(error)
      notify.show(`Ups, ${error}`, 'error', 3000)
      if (error.status == 401) {
        // refreshToken()
        // this.hydrationAlert(startHour, endHour, notificationEnabled)
      } else {
        console.log(error)
      }
    })
}

export const setHydrationAlert = async (
  startHour,
  endHour,
  notificationEnabled
) => {
  let respo
  const hydrationAlertConfig = {
    method: 'POST',
    url: `${ApiURL}/api/hydration_alert/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
    data: {
      start_hour: startHour,
      end_hour: endHour,
      notification_enabled: notificationEnabled,
    },
  }

  await axios(hydrationAlertConfig)
    .then((response) => {
      respo = response

      notify.show('Poprawnie ustawiono przypominanie o wodzie', 'success', 2000)
    })
    .catch((error) => {
      console.log(error)

      if (error.status == 401) {
      } else {
        console.log(error)
      }
    })
  return respo
}

export const deleteFeed = (feedId) => {
  const removeUserFeed = {
    method: 'DELETE',
    url: `${ApiURL}/api/feeds/${feedId}/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  axios(removeUserFeed)
    .then((response) => {
      if (
        response.status === 200 ||
        response.status === 201 ||
        response.status === 204
      ) {
        notify.show('Poprawnie usunięto podany wpis', 'success', 3000)
      }
    })
    .catch((error) => {
      console.log(error)

      if (error.status == 401) {
        // refreshToken()
        // this.deleteFeed(feedId)
      } else {
        console.log(error)
      }
    })
}

export const removeUserImages = (feedId) => {
  const removeUserImagesConfig = {
    method: 'DELETE',
    url: `${ApiURL}/api/feeds/${feedId}/delete_photos/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  axios(removeUserImagesConfig)
    .then((response) => {
      if (response.status === 200 || response.status === 201) {
        notify.show(
          'Poprawnie usunięto zdjęcia z podanego wpisu',
          'success',
          3000
        )
      }
    })
    .catch((error) => {
      console.log(error)

      if (error.status == 401) {
        // refreshToken()
        // this.removeUserImages()
      } else {
        console.log(error)
      }
    })
}

export const editUserFeedDimensions = (
  belly_circumference,
  hip_circumference,
  thigh_circumference,
  feedId
) => {
  const editUserTrainingDaysConfig = {
    method: 'PATCH',
    url: `${ApiURL}/api/feeds/${feedId}/`,
    data: {
      belly_circumference: belly_circumference,
      hip_circumference: hip_circumference,
      thigh_circumference: thigh_circumference,
    },
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  axios(editUserTrainingDaysConfig)
    .then((response) => {
      notify.show(
        'Poprawnie zaktualizowano dane o wymiarach dla tego wpisu',
        'success',
        2000
      )
    })

    .catch((error) => {
      notify.show(`Ups, ${error.status}`, 'error', 2000)
      if (error.status === 401) {
        // refreshToken()
        // this.editUserFeedDimensions(
        //   belly_circumference,
        //   hip_circumference,
        //   thigh_circumference,
        //   feedId
        // )
      }
    })
}

// export const getUserSubscriptionInfo = async () => {
//   let subscriptionInfo

//   const getUserSubscriptionInfoConfig = {
//     method: 'GET',
//     url: `${ApiURL}/!ENDPOINT!/`,
//     headers: {
//       Authorization: 'Bearer ' + cookie.load('accessToken'),
//     },
//   }

//   await axios(getUserSubscriptionInfoConfig)
//     .then((response) => {
//       subscriptionInfo = response
//     })
//     .catch((error) => {
//       notify.show(`Ups, ${error.}`, 'error', 2000)
//       if (error. === 401) {
//         refreshToken()
//       }
//     })
//   return subscriptionInfo
// }

export const deleteUser = async () => {
  let isUserDeleted = false
  const deleteUserConfig = {
    method: 'DELETE',
    url: `${ApiURL}/api/auth/users/delete_account/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  await axios(deleteUserConfig)
    .then((response) => {
      isUserDeleted = true
      notify.show('Poprawnie usunięto użytkownika', 'success', 2000)
    })
    .catch((error) => {
      notify.show(`Ups, ${error.status}`, 'error', 2000)
      if (error.status == 401) {
        // refreshToken()
      }
      isUserDeleted = false
    })
  return isUserDeleted
}

export const reportUsersMessage = async (userId, message) => {
  let successReport = false
  const reportUsersMessageConfig = {
    method: 'POST',
    url: `${ApiURL}/api/auth/users/${userId}/request_ban/`,
    data: {
      reported_message: message,
    },
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  await axios(reportUsersMessageConfig)
    .then((response) => {
      notify.show('Poprawnie zgłoszono wiadomość użytkownika', 'success', 2000)
      successReport = true
    })
    .catch((error, response) => {
      notify.show(`Ups, ${response.response.data.message}`, 'error', 2000)
      successReport = false
      if (error.status === 401) {
        // refreshToken()
      }
    })

  return successReport
}

export const editUserChatName = async (userName) => {
  const editUserChatNameConfig = {
    method: 'PATCH',
    url: `${ApiURL}/api/auth/users/set_chat_username/`,
    data: {
      chat_username: userName,
    },
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  await axios(editUserChatNameConfig)
    .then((response) => {})
    .catch((error) => {
      notify.show(`Ups, ${error.status}`, 'error', 2000)
      if (error.status == 401) {
        // refreshToken()
      }
    })
}

export const getUserChatName = async () => {
  let userName
  const getUserChatNameConfig = {
    method: 'GET',
    url: `${ApiURL}/api/auth/users/get_chat_username/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }
  await axios(getUserChatNameConfig)
    .then((response) => {
      userName = response.data.chat_username
    })
    .catch((error) => {
      notify.show(`Ups, ${error.status}`, 'error', 2000)
      if (error.status == 401) {
        // refreshToken()
      }
    })

  return userName
}

//   await axios(getUserSubscriptionInfoConfig)
//     .then((response) => {
//       subscriptionInfo = response
//     })
//     .catch((error) => {
//       notify.show(`Ups, ${error.}`, 'error', 2000)
//       if (error. === 401) {
//         refreshToken()
//       }
//     })
//   return subscriptionInfo
// }

// export const deleteUser = async () => {
//   let isUserDeleted = false
//   const deleteUserConfig = {
//     method: 'DELETE',
//     url: `${ApiURL}/api/auth/users/delete_account/`,
//     headers: {
//       Authorization: 'Bearer ' + cookie.load('accessToken'),
//     },
//   }

//   await axios(deleteUserConfig)
//     .then((response) => {
//       isUserDeleted = true
//       notify.show('Poprawnie usunięto użytkownika', 'success', 2000)
//     })
//     .catch((error) => {
//       notify.show(`Ups, ${error.}`, 'error', 2000)
//       if (error. === 401) {
//         refreshToken()
//       }
//       isUserDeleted = false
//     })
//   return isUserDeleted
// }

export const subscribeToNewsletter = async () => {
  const subscribeToNewsletterConfig = {
    method: 'POST',
    url: `${ApiURL}/api/auth/users/subscribe_newsletter/ `,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  await axios(subscribeToNewsletterConfig)
    .then((response) => {
      notify.show('Zapisano do subskrypcji newslettera', 'success', 2000)
    })
    .catch((error) => {
      notify.show(`Ups, ${error.status}`, 'error', 2000)
      if (error.status == 401) {
        // refreshToken()
      }
    })
}

export const unSubscribeNewsletter = async () => {
  const unSubscribeNewsletterConfig = {
    method: 'POST',
    url: `${ApiURL}/api/auth/users/unsubscribe_newsletter/ `,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  await axios(unSubscribeNewsletterConfig)
    .then((response) => {
      notify.show('Usunięto subskrypcje newslettera', 'success', 2000)
    })
    .catch((error) => {
      notify.show(`Ups, ${error.status}`, 'error', 2000)
      if (error.status == 401) {
        // refreshToken()
      }
    })
}

export const checkUserSubscriptionStatus = async () => {
  let subStatus
  const checkUserSubscriptionStatusConfig = {
    method: 'GET',
    url: `${ApiURL}/api/auth/users/subscription/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  await axios(checkUserSubscriptionStatusConfig)
    .then((response) => {
      subStatus = response.data
    })
    .catch(({ error, response }) => {
      // refreshToken()
    })
  return subStatus
}

// Zwrotka z produktów stripa dla paid content

export const getStripePaidContent = async () => {
  let paidContent

  const getStripePaidContent = {
    method: 'GET',
    url: `${ApiURL}/api/stripe_controller/stripe_products/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  await axios(getStripePaidContent)
    .then((response) => {
      paidContent = response.data
    })
    .catch(({ error, response }) => {})

  return paidContent
}

export const getUserStripeBoughtPackages = async () => {
  let userBoughtItems

  const getUserBoughtItems = {
    method: 'GET',
    url: `${ApiURL}/api/stripe_controller/stripe_products/my_purchases/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  await axios(getUserBoughtItems)
    .then((response) => {
      userBoughtItems = response.data
    })
    .catch(({ error, response }) => {})

  return userBoughtItems
}

export const getUserWeeklyActivity = async () => {
  let userWeeklyActivity

  const getUserWeeklyActivityConfig = {
    method: 'GET',
    url: `${ApiURL}/api/training/my_week/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  await axios(getUserWeeklyActivityConfig)
    .then((response) => {
      userWeeklyActivity = response.data
    })
    .catch(({ error, response }) => {})

  return userWeeklyActivity
}

export const getUserCurrentStage = async () => {
  let userCurrentStage

  const getUserCurrentStageConfig = {
    method: 'GET',
    url: `${ApiURL}/api/training/current_stage/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  await axios(getUserCurrentStageConfig)
    .then((response) => {
      userCurrentStage = response.data
    })
    .catch(({ error, response }) => {})

  return userCurrentStage
}

export const getAllAppFolders = async () => {
  let allFolders

  const obtainAllFolders = {
    method: 'GET',
    url: `${ApiURL}/api/vimeovideos/albums/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }
  await axios(obtainAllFolders)
    .then((response) => {
      allFolders = response.data
    })
    .catch(({ response, error }) => {
      console.log(error)
    })

  return allFolders
}

export const getFolders = async () => {
  let folders

  const obtainAllFolders = {
    method: 'GET',
    url: `${ApiURL}/api/vimeovideos/dashboard/all_albums/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }
  await axios(obtainAllFolders)
    .then((response) => {
      folders = response.data
    })
    .catch(({ response, error }) => {
      console.log(error)
    })

  return folders
}

export const getSingleFeed = async (id) => {
  let feed

  const obtainSingleFeed = {
    method: 'GET',
    url: `${ApiURL}/api/feeds/${id}/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }
  await axios(obtainSingleFeed)
    .then((response) => {
      feed = response.data
    })
    .catch(({ response, error }) => {
      console.log(error)
    })

  return feed
}

export const getMainpageAds = async () => {
  let ad

  const obtainAddData = {
    method: 'GET',
    url: `${ApiURL}/api/advertisements/active_ads/ad_details/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }
  await axios(obtainAddData)
    .then((response) => {
      ad = response.data
    })
    .catch(({ response, error }) => {})

  return ad
}

export const getMissingSteps = async () => {
  let missingStep

  const obtainMissingStepConfig = {
    method: 'GET',
    url: `${ApiURL}/api/auth/users/missing_steps/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }
  await axios(obtainMissingStepConfig)
    .then((response) => {
      missingStep = response.data
    })
    .catch(({ response, error }) => {
      console.log(error)
    })

  return missingStep
}

export const setUserBmr = async (weight, height, age, activityLevel, goal) => {
  let bmrResult

  var time = new Date()
  var milisecondsTime = time.getTime()

  const setUserBmrConfig = {
    method: 'POST',
    url: `${ApiURL}/api/diets/bmr/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
    data: {
      weight: parseInt(weight),
      height: parseInt(height),
      age: parseInt(age),
      activity_level: activityLevel,
      goal: goal,
    },
  }
  await axios(setUserBmrConfig)
    .then((response) => {
      bmrResult = response.data
      notify.show(
        'Poprawnie zapisano zapotrzebowanie kaloryczne',
        'success',
        2000
      )
    })
    .catch(({ response, error }) => {})

  return bmrResult
}

export const removeUserBmr = async () => {
  let bmrResult

  const removeUserBmrConfig = {
    method: 'DELETE',
    url: `${ApiURL}/api/diets/delete_my_bmr/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }
  await axios(removeUserBmrConfig)
    .then((response) => {
      bmrResult = response.data
      notify.show(
        'Poprawnie usunięto zapotrzebowanie kaloryczne',
        'success',
        2000
      )
    })
    .catch(({ response, error }) => {})

  return bmrResult
}

export const getUserBmr = async () => {
  let bmrResult

  const getUserBmrConfig = {
    method: 'GET',
    url: `${ApiURL}/api/diets/bmr/my_bmr/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }
  await axios(getUserBmrConfig)
    .then((response) => {
      bmrResult = response.data
    })
    .catch(({ response, error }) => {})

  return bmrResult
}

export const getPromoInfo = async () => {
  let promoInfo

  const getPromoInfoConfig = {
    method: 'GET',
    url: `${ApiURL}/api/auth/users/promo_banner/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }
  await axios(getPromoInfoConfig)
    .then((response) => {
      promoInfo = response.data
    })
    .catch(({ response, error }) => {})

  return promoInfo
}

export const getPortalInfo = async () => {
  let portalInfo

  const getPromoInfoConfig = {
    method: 'GET',
    url: `${ApiURL}/api/inappsubscriptions/stripe/get_stripe_customer/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }
  await axios(getPromoInfoConfig)
    .then((response) => {
      portalInfo = response.data
    })
    .catch(({ response, error }) => {
      console.log(error)

      if (response.status == 404) {
        portalInfo = 404
        notify.show(
          'Akcja nieudana. Zakup subskrypcję by móc nią zarządzać.',
          'error',
          2000
        )
      }
    })

  return portalInfo
}

export const activateAlbumAccess = async (albumId) => {
  let albumAccess

  const activateAlbumAccessConfig = {
    method: 'GET',
    url: `${ApiURL}/api/vimeovideos/temporary_album_access/activate_album_access/?album_id=${albumId}`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }
  await axios(activateAlbumAccessConfig)
    .then((response) => {
      albumAccess = response.data
    })
    .catch(({ response, error }) => {
      if (response.status == 404) {
        // portalInfo = 404
        notify.show(
          'Akcja nieudana. Zakup subskrypcję by móc nią zarządzać.',
          'error',
          2000
        )
      }
    })

  return albumAccess
}
